import {
  NewsCategoriesSection,
  NewsletterSection,
  MediaPressSection,
} from "@features/residential/components";

interface NewsUpdatesPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function NewsUpdatesPage({ hero, footer }: NewsUpdatesPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <NewsCategoriesSection />
      <NewsletterSection />
      <MediaPressSection />
      {footer}
    </div>
  );
}
